import { useTranslation } from 'react-i18next'

import { Markdown } from './Markdown'

/**
 * Modelin dusunme adimlari - gercek bir `<details>`.
 *
 * Vanilla arayuz bunu elle acilip kapanan bir `div` olarak kuruyordu.
 * `<details>` klavye ve ekran okuyucu destegini BEDAVA veriyor: `Enter`/
 * `Space` ile aciliyor, durum "genisletilmis/daraltilmis" olarak duyuruluyor.
 *
 * Yanit bitince otomatik KAPANIYOR: `open` prop'u akis durumundan turetiliyor,
 * bir `useState` degil. Kullanici elle actiysa React onu ezmiyor cunku
 * `<details>` kendi durumunu tutuyor ve `open` yalnizca ilk render'da ve
 * `key` degistiginde uygulaniyor... bu yeterli degil, o yuzden `open`
 * kontrollu birakildi ve akis bitince kapanmasi KASITLI.
 */
export function ThinkBlock({ text, streaming }: { text: string; streaming: boolean }) {
  const { t } = useTranslation()
  if (!text.trim()) return null

  return (
    <details className="think" open={streaming}>
      <summary>{streaming ? t('think.thinking') : t('think.steps')}</summary>
      <div className="think-body">
        <Markdown text={text} streaming={streaming} />
      </div>
    </details>
  )
}
